import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	exportButtonLabel: {
		id: 'software-deployments.header.export-button.export-button-label',
		defaultMessage: 'Export',
		description:
			'Label for the "Export" button on the Deployments page. When clicked, options for downloading/exporting deployments data are given (e.g. as a CSV file).',
	},
});
